var code = {
  successCode: "20000000",
  //成功
  errorCode: "50000001",
  //错误
  sqlError: "50000501",
  //sql异常
  nullError: "50000502",
  //空指针异常
  netError: "50000503",
  //网络异常
  sendMessageError: "50000504",
  //发送短信错误
  verifyCodeError: "50000506",
  //验证码错误
  noRegisterError: "50000507",
  //账号未注册
  pwdError: "50000508",
  //密码错误
  userExitError: "50000509",
  //用户已存在
  sessionErrorCode: "40000001",
  errCode: "50000512"
};
export default code;